import styled from "styled-components";

export const RowInputs = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	gap: 1rem;
	margin-bottom: 1rem;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
		grid-template-columns: 1fr 1fr;
	}

	@media (max-width: 560px) {
		grid-template-columns: 1fr;
	}
`;
